import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { HsnService } from '../../../services/index';

@Component({
    selector: 'add-edit-hsn-window',
    templateUrl: './addEditHsn.component.html'
})
export class AddEditHSNComponent implements OnInit {
    public title: string;
    public mode: string;
    public list: any[] = [];
    public hsndata: any[] = [];

    // trigger-variable for Ladda
    isLoading: boolean = false;
    @Output() hsnLoadEvent = new EventEmitter();

    constructor(private hsnService: HsnService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

    }

    ngOnInit(): void {
        setTimeout(() => {
            $('#hsn_code').focus();
        }, 100);
    }

    onSaveHsn(): void {
        let that = this;
        this.isLoading = true;
        this.hsnService
            .addUpdateHSN(this.hsndata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.hsnLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/hsncode/addEditHsn.component.ts